import { useState } from "react";
import { Outlet } from "react-router-dom";
import { FileText, X } from "lucide-react";
import { Link } from "react-router-dom";
import Sidebar from "./common/Sidebar";
import Header from "./common/Header";
import { useBusinessSettings } from "./contexts/BusinessSettingsContext";
import ScrollToTop from "./components/scrollbarTop/ScrollToTop";

export default function MainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { expandedLogoUrl, collapsedLogoUrl, siteConfig } =
    useBusinessSettings();

  const toggleSidebarCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="h-screen bg-gray-50 flex">
      <ScrollToTop />

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full bg-slate-50 border-r border-slate-200 transform transition-all duration-300 z-50 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } ${isSidebarCollapsed ? "lg:w-16" : "lg:w-56"} lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          <div
            className={`flex items-center ${
              isSidebarCollapsed ? "h-[64px] p-3" : "h-[72px] p-4"
            } border-b ${
              !isSidebarCollapsed && expandedLogoUrl
                ? "justify-center"
                : "justify-between"
            }`}
          >
            <Link
              to="/"
              className={`flex items-center ${
                expandedLogoUrl ? "justify-center w-full" : "gap-2"
              }`}
            >
              {isSidebarCollapsed ? (
                collapsedLogoUrl ? (
                  <div className="flex items-center justify-center ml-2">
                    <img
                      src={collapsedLogoUrl}
                      alt="Logo"
                      className="w-[50px] h-auto object-contain"
                      style={{ maxWidth: "50px", maxHeight: "50px" }}
                    />
                  </div>
                ) : (
                  <div
                    className={`w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center ml-2`}
                  >
                    <FileText className="w-5 h-5 text-white" />
                  </div>
                )
              ) : (
                expandedLogoUrl ? (
                  <img
                    src={expandedLogoUrl}
                    alt="Logo"
                    className="max-w-[150px] h-auto object-contain"
                  />
                ) : (
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                      <FileText className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <span className="text-lg font-semibold text-gray-900 block truncate">
                        {siteConfig?.site_name || "DOcIQ"}
                      </span>
                      <span className="text-xs text-gray-500 truncate">
                        {siteConfig?.site_description || "DocIQ"}
                      </span>
                    </div>
                  </div>
                )
              )}
            </Link>
            <button
              onClick={() => setIsSidebarOpen(false)}
              className="lg:hidden text-gray-500 hover:text-gray-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            isOpen={isSidebarOpen}
            onToggle={toggleSidebarCollapse} // This will now toggle collapse
            onClose={() => setIsSidebarOpen(false)}
          />
        </div>
      </aside>

      <div
        className={`flex flex-col flex-1 transition-all duration-300 overflow-y-auto custom-scrollbar1 ${
          isSidebarCollapsed ? "lg:ml-16" : "lg:ml-56"
        }`}
      >
        <Header
          onMenuClick={() => setIsSidebarOpen(true)}
          onToggleSidebarCollapse={toggleSidebarCollapse}
          isSidebarCollapsed={isSidebarCollapsed}
        />
        <main className="flex-1  lg:mx-4 sm:mx-8 my-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
